module.exports = __webpack_public_path__ + "static/media/thanhToanThatBai.1b17f9f7.svg";